import Container from "react-bootstrap/Container";
import Header from "../components/layout/header";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

interface DefaultProps {
	disablePadding?: boolean;
}

export default function Default(props: React.PropsWithChildren<DefaultProps>) {
	return (
		<div>
			<Header />
			<Container>
				<Row className="justify-content-md-center">
					<Col xs={12} lg={props.disablePadding ? 12 : 9} xl={props.disablePadding ? 12 : 8}>
						{props.children}
					</Col>
				</Row>
			</Container>
		</div>
	);
}
